module.exports = __webpack_public_path__ + "static/media/DT12.13ac363b.jpg";